import { useAlternativeUser } from "@/contexts/AlternativeUserContext";
import { useTelegramChatId } from "@/hooks/use-chat-id";
import { withAsyncHandler } from "@/lib/async-handler";
import { authService, StatusResponse } from "@/services";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";

export default function GlobalState({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, setUser } = useAlternativeUser();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const chatId = useTelegramChatId();

  useEffect(() => {
    const verifyAuthentication = async () => {
      await withAsyncHandler(
        () => authService.checkStatus(Number(chatId)),
        setIsLoading,
        {
          onSuccess: (res: StatusResponse) => {
            if (res.eventTemplateAlternativeUser) {
              setUser(res.eventTemplateAlternativeUser);
              if (window.location.pathname.includes("/auth")) {
                navigate("/");
              }
            }
          },
          onError: () => {
            navigate("/auth");
          },
          showErrorNotification: false,
        },
      );
    };

    if (!chatId) {
      navigate("/auth");
      return;
    }

    if (!user) {
      verifyAuthentication();
    }
  }, [user, chatId]);

  if (isLoading) {
    return <Loading open />;
  }

  return (
    <Box
      id="global-state"
      sx={{
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <>{children}</>
    </Box>
  );
}
